import styled from "styled-components";
import propTypes from "@styled-system/prop-types";

import Flex from "./Flex";

const Container = styled(Flex)({});

Container.displayName = "Container";

Container.defaultProps = {
  width: ["100%", null, null, null, "container"],
  mx: [null, null, null, null, "-15px"],
  px: ["15px", null, "31px", null, "15px"],
};

Container.propTypes = {
  ...propTypes.flexbox,
};

export default Container;
